import React from 'react';
import { SideModal, Input } from '@cokitchen/cokitchen-components';
import { MenuHorizontalIcon, NotificationIcon } from 'cokitchen-icons';
import { ReactComponent as ArrowBackIcon } from 'assets/icons/arrow-back.svg';
import './styles.scss';
import CreateList from './create-list';
import Profile from './profile';
import useDashboardContext from 'contexts/dashboard.context';
import { Link, useLocation } from 'react-router-dom';
import { ROUTE_KEYS, ROUTE_PREFIX } from 'utils/constants';
import HeaderInput from './header-input';
import CokitchenDropdown from 'components/sidebar/cokitchen-dropdown';
import Sidebar from 'components/sidebar';

const Header = () => {
  const { hasNotifications, showMobileSidebar, setShowMobileSidebar } = useDashboardContext();
  const { pathname } = useLocation();
  const isPricing = () => pathname.includes(ROUTE_KEYS.PRICING);
  const { customSearch, isCustomSearch, setCustomSearch } = useDashboardContext();

  return (
    <div className='px-3 lg:pr-14 py-4 border-b border-gray-13 flex flex-wrap gap-4 items-center text-sm font-medium h-[90px] z-100 '>
      <div className='grow flex items-center h-[100%] '>
        {isPricing() ? (
          <div className='lg:w-[250px] pr-4 mr-[25px] border-r border-gray-13 flex items-center h-full'>
            <Link
              to={`${ROUTE_PREFIX.FOOD}/${ROUTE_KEYS.OVERVIEW}`}
              className='flex justify-center mx-auto items-center gap-3'>
              <ArrowBackIcon className='w-8 h-8  bg-[#F4F1F1] rounded-full p-[5px] text-red-5 ' />
              <p className='font-semibold text-sm'>Return to dashboard </p>
            </Link>
          </div>
        ) : (
          <div className='inline-flex gap-2 items-center lg:hidden'>
            <span
              role='menubar'
              onClick={() => setShowMobileSidebar(true)}
              className='p-2 bg-black rounded-full text-white'>
              <MenuHorizontalIcon />
            </span>
            <CokitchenDropdown />
          </div>
        )}
        <div className='max-lg:hidden'>
          {isCustomSearch ? (
            <Input
              small
              inputClass='h-12 placeholder:text-sm max-w-[300px]'
              className='text-[14px] ml-4 max-w-[300px]'
              placeholder='Search'
              value={customSearch}
              onChange={(e) => {
                setCustomSearch(e.target.value);
              }}
            />
          ) : (
            <HeaderInput />
          )}
        </div>
      </div>

      <div className='flex items-center gap-4 flex-wrap'>
        <div className='max-lg:hidden flex items-center gap-7'>
          <CreateList />
          <div className='bg-[#e2e3e4] h-6 w-[1px]' />
          <div className='relative'>
            <NotificationIcon className='w-12 h-12 p-[10px] rounded-full border border-gray-15 text-gray-8' />
            {hasNotifications && (
              <div className='w-3 h-3 absolute right-[11.5px] top-[8px] bg-red-5 rounded-full border-2 border-white' />
            )}
          </div>
        </div>

        <Profile />
      </div>
      <SideModal
        title={<CreateList />}
        isOpen={showMobileSidebar}
        onRequestClose={() => setShowMobileSidebar(false)}
        hideFooter>
        <HeaderInput />

        <Sidebar />
      </SideModal>
    </div>
  );
};

export default Header;
